export default __webpack_public_path__ + "src/images/packages/oceana-reserve/4d6bc6202b36ffb260b568c11e4dc97d-4.jpg";